<template>
  <div v-if="false" class="view-667">
    <div class="rectangle-85-12"></div>
    <div class="view-668">
      <x182
        :number="x1821Props.number"
        :group234="x1821Props.group234"
        :text524="x1821Props.text524"
        :className="x1821Props.className"
      />
      <img
        class="line-22-8"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
        alt="Line 22"
      />
      <x182
        :number="x1822Props.number"
        :group234="x1822Props.group234"
        :text524="x1822Props.text524"
        :className="x1822Props.className"
      />
      <img
        class="line-2-2"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
        alt="Line 22"
      />
      <x362
        :number="x3621Props.number"
        :group234="x3621Props.group234"
        :text520="x3621Props.text520"
        :text519="x3621Props.text519"
        :className="x3621Props.className"
      />
      <img
        class="line-2-2"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-23-1.svg"
        alt="Line 23"
      />
      <x362
        :number="x3622Props.number"
        :group234="x3622Props.group234"
        :text520="x3622Props.text520"
        :text519="x3622Props.text519"
        :className="x3622Props.className"
      />
      <img
        class="line-24-3"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-24-6.svg"
        alt="Line 24"
      />
      <x362
        :number="x3623Props.number"
        :group234="x3623Props.group234"
        :text520="x3623Props.text520"
        :text519="x3623Props.text519"
        :className="x3623Props.className"
      />
      <div class="x6-17 poppins-bold-white-15px">
        <div class="rectangle-85-13"></div>
        <div class="text-891">86,4</div>
        <div class="text-892">Вы</div>
        <div class="group-235-17"></div>
        <div class="number-24">20</div>
      </div>
    </div>
    <p class="text-903 poppins-bold-black-17px">ТОП - 5 студентов на платформе</p>
  </div>
</template>

<script>
import X182 from "./X182";
import X362 from "./X362";
export default {
  name: "View57",
  components: {
    X182,
    X362,
  },
  props: ["x1821Props", "x1822Props", "x3621Props", "x3622Props", "x3623Props"],
};
</script>

<style>
.view-667,
.view-669,
.view-671,
.view-673 {
  height: 423px;
  left: 956px;
  position: absolute;
  top: 635px;
  width: 388px;
}

.rectangle-85-12,
.rectangle-85-14,
.rectangle-85-16,
.rectangle-85-18 {
  background-color: var(--white);
  border-radius: 10px;
  height: 423px;
  left: 0;
  position: absolute;
  top: 0;
  width: 386px;
}

.view-668,
.view-670,
.view-672,
.view-674 {
  display: flex;
  flex-direction: column;
  height: 359px;
  left: calc(50% - 194px);
  position: absolute;
  top: 64px;
  width: 386px;
}

.line-22-8,
.line-22-9,
.line-22-10,
.line-22-11 {
  align-self: center;
  height: 1px;
  margin-left: 6px;
  margin-top: 3.5px;
  width: 340.01px;
}

.line-2-2,
.line-2-3,
.line-2-4,
.line-2-5 {
  align-self: center;
  height: 1px;
  margin-left: 6px;
  margin-top: 2.5px;
  width: 340.01px;
}

.line-24-3,
.line-24-4,
.line-24-5,
.line-24-6 {
  align-self: center;
  height: 1px;
  margin-left: 6px;
  margin-top: 3px;
  width: 340.01px;
}

.x6-17,
.x6-18,
.x6-19,
.x6-20 {
  height: 52px;
  margin-top: 8px;
  position: relative;
  width: 392px;
}

.rectangle-85-13,
.rectangle-85-15,
.rectangle-85-17,
.rectangle-85-19 {
  background-color: var(--azure-radiance-3);
  border-radius: 10px;
  height: 52px;
  left: 0;
  position: absolute;
  top: 0;
  width: 386px;
}

.text-891,
.text-1546,
.text-1852,
.text-2044 {
  left: 331px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.text-892,
.text-1547,
.text-1853,
.text-2045 {
  left: 111px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.group-235-17,
.group-235-18,
.group-235-19,
.group-235-20 {
  aspect-ratio: 1;
  background-color: var(--alto);
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/image-12-2@2x.png);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 60px;
  height: 50px;
  left: 47px;
  position: absolute;
  top: 1px;
  width: 50px;
}

.number-24,
.number-25,
.number-26,
.number-27 {
  left: 20px;
  letter-spacing: 0.3px;
  line-height: normal;
  position: absolute;
  top: 13px;
}

.text-903,
.text-1558,
.text-1864,
.text-2056 {
  left: 49px;
  letter-spacing: 0.34px;
  line-height: normal;
  position: absolute;
  top: 12px;
}
</style>
